import React, { FC } from 'react';

import { Box } from '@mui/material';
import { TermsOfUseText } from './TermsOfUseText';

/**
 * Generated from https://docs.google.com/document/d/1uOk1-tHvZTOrfWF_VEZmKqOvsMFqfP4l9FmnKO7kabg
 * Download as .html & adapted for React
 */
export const TermsOfUse: FC = () => {
  return (
    <Box
      sx={(theme) => ({
        display: 'grid',
        gridTemplate: 'repeat(3, auto) / repeat(2, auto)',

        [theme.breakpoints.down('md')]: {
          gridTemplate: 'repeat(3, min-content) / repeat(2, auto)',
          justifyItems: 'center',
          gap: '1.25rem 0',
        },

        [theme.breakpoints.down('sm')]: {
          overflowY: 'auto',
          background: 'white',
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyItems: 'revert',
          gap: 0,
        },
      })}
    >
      <Box
        sx={(theme) => ({
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '59.5rem',
          borderRadius: '12px',
          background: 'white',
          gridRow: '1/3',
          gridColumn: '1/-1',
          alignSelf: 'center',
          justifySelf: 'center',
          px: 12,
          pt: 4,
          my: 4,
          [theme.breakpoints.down('md')]: {
            px: 8,
            gridRow: 2,
            mt: 1,
            width: '90%',
          },
          [theme.breakpoints.down('sm')]: {
            display: 'contents',
            px: 0,
          },
        })}
      >
        <TermsOfUseText></TermsOfUseText>
      </Box>
    </Box>
  );
};
